/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextFieldModule } from '@angular/cdk/text-field';
import { FormsModule } from '@angular/forms';

/**
 * Module imports.
 */
import { UserProfilePicModule } from './../user-pofile-pic/user-profile-pic.module';
import { DirectivesModule } from './../../directives/directives.module';
import { WalkthroughModule } from './../../walkthrough/walkthrough.module';
/**
 * Component imports.
 */
import { ProductCommentBoxComponent } from './product-comment-box.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SuggestionListForTagUsersComponent } from './../suggestion-list-for-tag-users/suggestion-list-for-tag-users.component';


@NgModule({
  declarations: [
    ProductCommentBoxComponent,
    SuggestionListForTagUsersComponent
  ],
  imports: [
    CommonModule,
    UserProfilePicModule,
    FormsModule,
    DirectivesModule,
    TextFieldModule,
    WalkthroughModule,
    InfiniteScrollModule,
    PerfectScrollbarModule
  ],
  exports: [
    ProductCommentBoxComponent,
    SuggestionListForTagUsersComponent,
    InfiniteScrollModule,
    PerfectScrollbarModule
  ]
})
export class ProductCommentBoxModule { }
